
import { useEffect, useState } from 'react';
import ViewProduct from './../../../components/monaliza/product/ViewProduct';
import { getProductAsync, getRandomProductAsync } from '../../../app/store/reducers/product/productReducer';
import { useParams, useLocation } from 'react-router-dom';



const ProductView = () => {
  const {id} = useParams()
  const location = useLocation();
  const [product, setProduct] = useState(null)

  
  const loadProduct = async (id) => {
    if (location.pathname?.includes('random')) {
      await getRandomProductAsync({id})
      .then((response) => {
        setProduct(response)
      })
      .catch((error) => {
        setProduct(null)
      })
    } else {
      await getProductAsync({id})
      .then((response) => {
        setProduct(response)
      })
      .catch((error) => {
        setProduct(null)
      })
    }
  }

  useEffect(() => {
    loadProduct(id)
  },[id])


  if (!product) {
    return <>loading...</>
  }

  return (
    <>
        <ViewProduct product={product}/>
    </>
  )
}

export default ProductView